export enum SIDE_PANEL_SIZES {
    MEDIUM = 'MEDIUM',
    LARGE = 'LARGE',
    FULL = 'FULL',
}